package no.vareflow.app.data.local

/**
 * Browser storage: window.localStorage, with every key prefixed so several apps on the same
 * domain cannot clash. Data stays in this browser profile only; the cloud is the shared copy.
 */
class BrowserKeyValueStore(private val prefix: String = "vareflow.") : KeyValueStore {
    private val storage: dynamic = js("globalThis.localStorage")

    override fun getString(key: String): String? {
        val value: dynamic = storage.getItem(prefix + key)
        return if (value == null) null else value as String
    }

    override fun putStrings(values: Map<String, String?>) {
        for ((key, value) in values) {
            if (value == null) storage.removeItem(prefix + key) else storage.setItem(prefix + key, value)
        }
    }
}
